/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import PurchaseByInvoiceTable from './PurchaseByInvoiceTable';
import Filter from './filter';

import './styles.scss';
import ButtonRefresh from 'components/base/ButtonRefresh';
import queryClient from 'service/queryClient';

export const invoiceBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'reports',
    url: '/reports/purchase/invoice'
  },
  {
    label: 'purchase',
    url: '/reports/purchase/invoice'
  },

  {
    label: 'purchase_invoice',
    active: true
  }
];

const PurchaseByInvoice = () => {
  const { t } = useTranslation();

  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [optionSenderId, setOptionSenderId] = useState(null);
  const [warehouseId, setWarehouseId] = useState(null);
  const [currencyId, setCurrencyId] = useState(null);
  const [typeId, setTypeId] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [filialId, setFilialId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [labeledVisibleFields, setLabeledVisibleFields] = useState<any>('');

  return (
    <div>
      <PageBreadcrumb items={invoiceBreadcrumbItems} />
      <div>
        <div className="mb-5 d-flex gap-2 align-items-center">
          <h2>{t('purchase_invoice')}</h2>
          <ButtonRefresh
            onRefresh={() => queryClient.refetchQueries('GET_REPORTS')}
          />
        </div>

        <Filter
          dateFrom={dateFrom}
          dateTo={dateTo}
          setDateFrom={setDateFrom}
          setDateTo={setDateTo}
          setOptionSenderId={setOptionSenderId}
          setWarehouseId={setWarehouseId}
          setCurrencyId={setCurrencyId}
          setTypeId={setTypeId}
          setPaymentId={setPaymentId}
          optionSenderId={optionSenderId}
          warehouseId={warehouseId}
          currencyId={currencyId}
          typeId={typeId}
          paymentId={paymentId}
          setCurrentPage={setCurrentPage}
          setFilialId={setFilialId}
          filialId={filialId}
          labeledVisibleFields={labeledVisibleFields}
        />
        <PurchaseByInvoiceTable
          dateFrom={dateFrom}
          dateTo={dateTo}
          optionSenderId={optionSenderId}
          warehouseId={warehouseId}
          currencyId={currencyId}
          typeId={typeId}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          paymentId={paymentId}
          filialId={filialId}
          setLabeledVisibleFields={setLabeledVisibleFields}
        />
      </div>
    </div>
  );
};

export default PurchaseByInvoice;
